































import { State, Getter, Action, namespace } from 'vuex-class'
import { Vue, Prop, Component, Watch } from 'vue-property-decorator'
import _ from 'lodash'
import HttpRequestServiceWithToken from '@/services/HttpRequestServiceWithToken'
import VueExtendedBaseComponent from '@/VueExtendedBaseComponent.vue'
import CustomMap from '@/components/CustomMap.vue'
import {IUser} from '@/store/modules/views/user/states'
import {IRegisterFormData} from '@/store/modules/views/register/states'

@Component({
  components: { CustomMap },
})
export default class EditLeaderDialog extends VueExtendedBaseComponent {
  @Prop({ default: '' }) private status!: string
  @Prop() private open!: boolean
  @Prop() private callback!: () => void
  @Prop() private getList!: () => Promise<void>
  @Prop() private user!: IUser & {role: string, permissions: string[], accounts: string[], metadate: string[]}
  private options = {
    page: 1,
    sortBy: ['createdAt'],
    sortDesc: [true],
    itemsPerPage: 1000,
    search: '',
  }

  private optionUser = {
    page: 1,
    sortBy: ['createdAt'],
    sortDesc: [true],
    itemsPerPage: 1000,
    search: '',
  }
  private valid = false
  private useritems = ''
  private centeritems = ''
  private name = ''
  private urlCenter = ''
  private loading = false
  get formInstant(): Vue & {
    validate: () => any
    resetValidation: () => any
    reset: () => any,
  } {
    return this.$refs.form as Vue & {
      validate: () => any
      resetValidation: () => any
      reset: () => any,
    }
  }

  @Getter('center/centerLists')
  private centerItemLists!: () => void

  get openDialog() {
    return this.open
  }

  @Getter('user/userLists')
  private userItemLists!: () => void

  @Action('user/getUserListByRoleId')
  private getUserList!: (headerParams: {
    headers: {
      page: number
      limit: number
      sortBy: string
      sortDesc: boolean
      search: string
      filter: string,
    },
    id: string,
  }) => void

  // tslint:disable-next-line:adjacent-overload-signatures
  set openDialog(value: boolean) {
    this.$emit('update:open', false)
  }

  public async created() {
    // this.urlCenter = `${process.env.VUE_APP_API_URL}/v1/all/center/${this.user.centerId}`
    this.name = `${this.user.prefix || ''}${this.user.firstname} ${this.user.lastname}`
    this.centeritems = this.user.centerId
    // await Promise.all([
    //   this.getUserCenter(),
    // ])
  }

  get centerLists() {
    return this.centerItemLists
  }

  // private async getUserCenter() {
  //   return await HttpRequestServiceWithToken
  //       .get(this.urlCenter, {}, ( response: { name: string, _id: string }) => {
  //         this.centeritems = response._id
  //         return response
  //       })
  // }

  get editLeaderDialogOption() {
    return {
      justify: 'start',
      button: {
        justify: 'center',
        cancelButton: {
          title: 'ปิด',
          action: this.closeDialog,
          height: '30',
        },
        submitButton: {
          title: 'บันทึก',
          action: this.editLeaderAction,
          loading: this.loading,
          height: '30',
        },
      },
    }
  }

  get invalidateInput() {
    return _.some(
        [],
        (item) => item !== true,
    )
  }


  private requireSelect(value) { return [(v) => !!v || 'จำเป็นต้องเลือก'] }

  private async editLeaderAction() {
    const validate = this.formInstant.validate()
    if (validate) {
      const LeaderData = {
        edit: {
          role: 'ผู้ดูแลประจำศูนย์บริการ',
          centerId: this.centeritems,
          metadata: {
            centerId: this.centeritems,
          },
        },
      }
      this.loading = true
      try {
        await HttpRequestServiceWithToken.putByLevel(`${process.env.VUE_APP_API_URL}/v1`,
            `user/${this.user._id}`,
            LeaderData.edit,
        ),
            this.updateSnackbar({txt: 'บันทึกผู้ดูแลประจำศูนย์บริการสำเร็จ.', type: 'success'})
        await this.callback()
        this.loading = false
        this.closeDialog()
      } catch (e) {
        this.loading = false
      }
    } else {
      return false
    }
  }

  private closeDialog() {
    this.$emit('update:open', false)
  }
}
